export const SOL_BOOT_SPLASH_ELEMENT_ID = 'sol-boot-splash';
export const SOL_BOOTING_HTML_CLASS = 'sol-booting';

export function dismissSolBootSplash() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.remove(SOL_BOOTING_HTML_CLASS);
  document.getElementById(SOL_BOOT_SPLASH_ELEMENT_ID)?.remove();
}
